import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { Icons, Images } from '../../assets';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmationModal from '../../modalComponents/ConfirmationModal';
import { logout } from '../../service/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { saveMicroAppList } from '../../redux/reducers/adminSlice';

const Sidebar = () => {

    const microApps = [
        { id: '1', label: "Dashboard", value: "dashboard", icon: "dashboard" },
        { id: '2', label: "Manage Users", value: "users", icon: "userIcon" },
        { id: '3', label: "Manage admins", value: "manageAdmins", icon: "manageAdmins" },
        { id: '4', label: "Manage User Roles", value: "manageUserRoles", icon: "userIcon" },
        { id: '5', label: "Product Catalog", value: "product-catalog", icon: "productCatalog" },
        { id: '6', label: "Resources", value: "resources", icon: "resources" },
        { id: '7', label: "Loyalty Program", value: "loyalty-program", icon: "star" },
        { id: '8', label: "Rewards", value: "rewards", icon: "rewards" },
        { id: '9', label: "Retailer TOD", value: "retailer-tod", icon: "fileText" },
        { id: '10', label: "Redeem Rewards", value: "redeemRewards", icon: "rewards" },
        { id: '11', label: "Product Feedback", value: "feedback", icon: "feedback" },
        { id: '12', label: "Product Enquiry", value: "product-enquiry", icon: "enquiry" },
        { id: '13', label: "Contact Form", value: "contactForm", icon: "contactLog" },
        { id: '14', label: "Manage Content", value: "manageContent", icon: "content" },
        { id: '15', label: "Notifications", value: "notification", icon: "notification" },
        { id: '16', label: "QR Code", value: "qrcode", icon: "qrCode" },
        { id: '17', label: "Reports", value: "report", icon: "report" },
        { id: '18', label: "Add Points", value: "add-points", icon: "addpoints" },
        { id: '19', label: "App Analytics", value: "appAnalytics", icon: "report" },
        { id: '20', label: "Logout", value: "logout", icon: "logout" },
    ]

    const microAppGroups = {
        "Dashboard & Analytics": ["dashboard", "appAnalytics", "report"],
        "User Management": ["users", "manageAdmins", "manageUserRoles"],
        "Content & Catalog": ["product-catalog", "resources", "manageContent"],
        "Engagement & Communication": ["product-enquiry", "contactForm", "notification", "feedback"],
        "Rewards & Loyalty": ["loyalty-program", "rewards", "redeemRewards", "retailer-tod", "add-points"],
    };

    const groupIcons = {
        "Dashboard & Analytics": Icons.dashboard,
        "User Management": Icons.userIcon,
        "Content & Catalog": Icons.resources,
        "Engagement & Communication": Icons.notification,
        "Rewards & Loyalty": Icons.rewards,
    };





    const [isOpen, setIsOpen] = useState(true)
    const [openGroups, setOpenGroups] = useState({});
    const [microAppList, setMicroAppList] = useState(microApps)
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [activeMicroApp, setActiveMicroApp] = useState('dashboard')
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const userPermission = useSelector((state) => state.auth.userPermission);

    useEffect(() => {
        if (userPermission?.length > 0) {
            const filteredMicroApps = microApps.filter(microApp => {
                const arrItem = userPermission.find(item => item.title === microApp.label);
                return arrItem && arrItem.view;
            });

            const excludedLabels = microApps.filter(microApp =>
                !userPermission.some(item => item.title === microApp.label)
            );
            const sortedMicroApps = [...filteredMicroApps, ...excludedLabels].sort((a, b) => a.id - b.id);

            setMicroAppList(sortedMicroApps);
            dispatch(saveMicroAppList(sortedMicroApps))
            setActiveMicroApp(sortedMicroApps?.at(0)?.value)
        } else {
            dispatch(saveMicroAppList(microAppList))
        }
    }, [userPermission])

    useEffect(() => {
        if (location?.pathname) {
            const pathName = location?.pathname?.split('/')
            const params = pathName[pathName?.length - 1]
            if (microAppList?.filter((x) => x?.value === params)?.at(0) && params !== 'logout') {
                setActiveMicroApp(params)
            } else {
                setActiveMicroApp('dashboard')
            }
        }
    }, [location])

    // useEffect(() => {
    //     setTimeout(() => {
    //         setIsOpen(true)
    //     }, 100)
    // }, [])

    const handleRedirect = (key) => {
        if (key === 'logout') {
            setShowLogoutModal(true)
        } else {
            setActiveMicroApp(key)
            navigate(`/admin/${key}`)
        }
    }

    const handleClose = () => {
        setShowLogoutModal(false)
    }

    const logoutConfirmation = () => {
        logout()
    }

    const toggleGroup = (groupTitle) => {
        setOpenGroups(prev => ({
            ...prev,
            [groupTitle]: !prev[groupTitle]
        }));
    };

    return (
        <>
            <div className={`sidebar-scroller ${classes.sidebarWrapper} ${isOpen ? classes.sideBarOpen : ''}`}>
                {Object.entries(microAppGroups).map(([groupTitle, values]) => {
                    const groupItems = microAppList.filter(app => values.includes(app.value));

                    if (!groupItems.length) return null;

                    return (
                        <div key={groupTitle} className={classes.sidebarGroup}>
                            <div className={classes.groupHeader} onClick={() => toggleGroup(groupTitle)} >
                                <div className={classes.microAppLogo}>
                                    <img src={groupIcons[groupTitle]} alt="" />
                                </div>
                                <div className={classes.microAppLable}>{groupTitle}</div>
                            </div>

                            {openGroups[groupTitle] && (
                                <div className={classes.groupItems}>
                                    {groupItems.map((item) => (
                                        <div key={item.value} className={`${classes.microAppWrap} ${activeMicroApp === item.value ? classes.microAppActive : ''} flex items-center`} onClick={() => handleRedirect(item.value)} >
                                            <div className={classes.microAppLogo}>
                                                <img src={Icons[item.icon]} alt="" />
                                            </div>
                                            <div className={classes.microAppLable}>{item.label}</div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}

                {microAppList
                    .filter(app => !Object.values(microAppGroups).flat().includes(app.value))
                    .map(app => (
                        <div
                            key={app.value}
                            className={`${classes.groupHeader} ${activeMicroApp === app.value ? classes.microAppActive : ''}`}
                            onClick={() => handleRedirect(app.value)}
                        >
                            <div className={classes.microAppLogo}>
                                <img src={Icons[app.icon]} alt="" />
                            </div>
                            <div className={classes.microAppLable}>{app.label}</div>
                        </div>
                    ))}
            </div>

            {
                showLogoutModal ?
                    <ConfirmationModal
                        isOpen={showLogoutModal}
                        handleSuccess={logoutConfirmation}
                        closePopUp={handleClose}
                        warningText={'Confirm Logout'}
                        modalText={'Are you sure you want to logout?'}
                        confirmText={'Logout'}
                        cancelText={'Cancel'}
                        primaryBtnConfirm
                        actionSwap
                    />
                    : null
            }
        </>
    );
}

export default Sidebar